
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kolefnisutreikningur",
      function () {
        return require("private-next-pages/kolefnisutreikningur.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kolefnisutreikningur"])
      });
    }
  